// extracted by mini-css-extract-plugin
module.exports = {"countColumn":"countColumn_countColumn__7Id6A","countText":"countColumn_countText__2etWm","titleText":"countColumn_titleText__22zf3"};